/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */

/**
 * Piecewise-linear German projector with explicit fail/top anchors.
 */
export interface GermanBandedProjector {
  type?: 'german_banded';
  /**
   * @minimum 0
   * @maximum 1
   */
  failAt?: number;
  /**
   * @minimum 0
   * @maximum 1
   */
  topAt?: number;
}
